const Clipboard = require('clipboard');

Rover.utils = Rover.utils || {};
Rover.utils.strings = Rover.utils.strings || {};

export const possessive = str => {
  if (str.slice(-1).toLowerCase() === 's') {
    return `${str}'`;
  }
  return `${str}'s`;
};

Rover.utils.formatPhoneNumber = function(e164Number) {
  if (!e164Number) {
    return;
  }
  return `(${e164Number.slice(-10, -7)}) ${e164Number.slice(-7, -4)}-${e164Number.slice(-4)}`;
};

Rover.utils.capitalizeFirstLetter = function(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

Rover.utils.syndeticJoin = function(arr, conjunction) {
  if (!conjunction) {
    conjunction = 'and';
  }

  if (arr.length === 1) {
    arr = arr[0];
  } else if (arr.length === 2) {
    arr = arr.join(` ${conjunction} `);
  } else {
    let first = arr.splice(0, arr.length - 1),
      last = arr.splice(arr.length - 1)[0];

    arr = `${first.join(', ')}, ${conjunction} ${last}`;
  }
  return arr;
};

Rover.utils.getCsrfToken = function() {
  let csrfCookieName;
  const $meta = $('meta[name=csrf-cookie-name]');

  if ($meta.length > 0) {
    csrfCookieName = $meta.attr('content');
  } else {
    csrfCookieName = 'csrftoken';
  }

  return $.cookie(csrfCookieName);
};

export const copyTextToClipboard = (triggerSelector, successCallback) => {
  let callbackForSuccess = successCallback;
  if (typeof successCallback !== 'function') callbackForSuccess = () => {};
  const board = new Clipboard(triggerSelector);
  board.on('success', callbackForSuccess);
  board.on('error', e => {});
};

export default {
  possessive,
  copyTextToClipboard,
};



// WEBPACK FOOTER //
// ../utilities/string.js